// Month names
export const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Generate forecast months dynamically: current month to 3 years ahead
export const generateForecastMonths = () => {
  const months = [];
  const now = new Date();
  let year = now.getFullYear();
  let month = now.getMonth(); // 0-indexed

  for (let i = 0; i < 36; i++) {
    months.push({
      key: `${year}-${String(month + 1).padStart(2, '0')}`,
      label: `${MONTH_NAMES[month]}-${String(year).slice(2)}`,
      fullLabel: `${MONTH_NAMES[month]} ${year}`,
      month: month,
      year: year,
      index: i
    });

    month++;
    if (month > 11) {
      month = 0;
      year++;
    }
  }
  return months;
};

export const FORECAST_MONTHS = generateForecastMonths();

// Default assumptions
export const DEFAULT_ASSUMPTIONS = {
  // Payroll
  alexSalary: 2500,
  ellisSalary: 2500,
  shannonSalary: 2000,
  amieSalary: 1800,
  andySalary: 2500,
  // Fixed Overheads
  rent: 1042,
  businessRates: 162,
  electric: 180,
  internet: 300,
  phoneSystem: 50,
  eeMobiles: 120,
  bupaHealth: 190,
  insurance: 54.7,
  // Subscriptions
  accountant: 270,
  hitched: 317.12,
  emailsCRM: 236.59,
  // Marketing
  weddingFairs: 1000,
  fuelCards: 800,
  agencyAds: 5000,
  // Variable
  subcontractors: 1000,
  subcontractorsPeak: 6000,
  subcontractorsOther: 2500,
  repairsMaintenance: 375,
  miscTravel: 300,
  otherVariable: 250,
  // Revenue
  avgWeddingValue: 3200,
  openingBalance: 0
};

// Scenario wedding counts (values computed dynamically from avg wedding value)
export const SCENARIO_WEDDINGS = { A: 3, B: 5, C: 10, D: 15, E: 20, F: 25 };

export const formatCurrency = (value) => {
  const num = Number(value) || 0;
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num);
};

export const formatCurrencyFull = (value) => {
  const num = Number(value) || 0;
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};
